export default __webpack_public_path__ + "static/media/MP.62bad8df.svg";